module.exports = __webpack_public_path__ + "static/media/blancDeNegres.d312f6c0.png";